/**
 * Keep-Alive Service Configuration
 * 
 * IMPORTANT: This service only works when users have the frontend open in their browser.
 * For 24/7 backend keep-alive, use an external service like UptimeRobot.
 * See KEEP_ALIVE_SOLUTIONS.md for recommended approaches.
 * 
 * This service is still useful for:
 * - Keeping backend warm during active user sessions
 * - Improving response times for active users
 * - Serving as a backup to external monitoring
 */

export const KEEP_ALIVE_CONFIG = {
  // Ping interval in milliseconds (default: 10 minutes)
  // Render free tier sleeps after 15 minutes, so 10 minutes is safe
  PING_INTERVAL: 10 * 60 * 1000,

  // Enable/disable keep-alive service
  ENABLED: true,

  // Log ping activity to console
  VERBOSE_LOGGING: true,

  // Endpoint to ping (relative to API base URL)
  HEALTH_ENDPOINT: '/health',
};

export default KEEP_ALIVE_CONFIG;
